const ViewInvoice = () => import('../../../components/Buyers/Invoice/ViewInvoice.vue')

export default [{
  name: 'ViewInvoice',
  path: 'viewinvoice',
  component: ViewInvoice,
  meta: {requiresAuth: true}
}]



// WEBPACK FOOTER //
// ./src/router/home/reports/index.js